import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Flex, Layout } from 'antd';
import { useAppSelector } from 'app/hooks';
import Footer from 'components/Footer/Footer';
import If from 'components/If';
import Inactivity from 'components/Inactivity';
import layoutStyles from 'components/Layout/Layout.module.scss';
import { selectUserSignInStatus } from 'services/session/sessionSelectors';
import { LEGAL_PATHS } from 'utils/constants';

/**
 * identityWeb monitors idle time across the whole enrollment module and nowhere else
 * unauthenticated (`enrollment-main.component.ts:115`), so the monitor is scoped to those paths
 * rather than mounted for every `UnAuthRoute` page.
 */
const IDLE_MONITORED_PATHS = ['/enrollment'];
// Angular's enrollment FAQ sat outside the enrollment module, so it never timed out
const IDLE_EXEMPT_PATHS = [LEGAL_PATHS.enrollmentFaqs];

function UnAuthRoute() {
  const isLogin = useAppSelector(selectUserSignInStatus);
  const location = useLocation();
  const matchesPath = (path: string) => location.pathname.startsWith(path);
  const isEnrolling =
    IDLE_MONITORED_PATHS.some(matchesPath) &&
    !IDLE_EXEMPT_PATHS.some(matchesPath);

  if (isLogin) {
    return (
      <Navigate
        to={{ pathname: '/dashboard', search: location.search }}
        replace
      />
    );
  }

  return (
    <Flex vertical className={`${layoutStyles.contentWrapper} alignStretch`}>
      <Layout.Content
        className={`${layoutStyles.content} verticalFlex alignStretch`}
      >
        <Flex vertical className={layoutStyles.pageSectionWrapper}>
          <Outlet />
        </Flex>
      </Layout.Content>
      <If condition={isEnrolling}>
        <Inactivity unauthenticated />
      </If>
      <Footer />
    </Flex>
  );
}

export default UnAuthRoute;
